var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { IGetShareOptionsUseCaseType } from '../../../Domain/UseCases/Application/GetShareOptionsUseCase/IGetShareOptionsUseCase';
import { reactive } from '../../Decorators/Reactive';
import { injectable } from '../../../Data/Decorators/Injectable';
import { inject } from '../../../Data/Decorators/Inject';
import * as Clipboard from 'expo-clipboard';
import { Platform, Share } from 'react-native';
let ShareViewModel = class ShareViewModel {
    constructor(getShareOptions) {
        this.getShareOptions = getShareOptions;
        this.viewData = {
            options: []
        };
        this.onPress = this.onPress.bind(this);
        this.share = this.share.bind(this);
        this.getShareOptions.execute().observe(this, options => this.updateViewData({ options }));
    }
    share(text, data) {
        if (Platform.OS === 'web') {
            return this.onPress(text, { key: 'copy' });
        }
        if (Platform.OS === 'android') {
            return Share.share({ url: text, title: data === null || data === void 0 ? void 0 : data.title, message: text }, { subject: data === null || data === void 0 ? void 0 : data.subject }).then(() => ({ key: 'unknown' }));
        }
        return Share.share({ url: text, title: data === null || data === void 0 ? void 0 : data.title }, { subject: data === null || data === void 0 ? void 0 : data.subject }).then(() => ({ key: 'unknown' }));
    }
    onPress(text, option) {
        if (option.key === 'copy') {
            if (Platform.OS === 'web') {
                return navigator.clipboard.writeText(text)
                    .then(() => option);
            }
            return Clipboard.setStringAsync(text)
                .then(isSuccessful => {
                if (!isSuccessful) {
                    return Promise.reject(new Error(`Unsuccessful copy!`));
                }
                return option;
            });
        }
        return Promise.resolve(option);
    }
    updateViewData(update) {
        this.viewData = Object.assign(Object.assign({}, this.viewData), update);
    }
};
__decorate([
    reactive(),
    __metadata("design:type", Object)
], ShareViewModel.prototype, "viewData", void 0);
ShareViewModel = __decorate([
    injectable(),
    __param(0, inject(IGetShareOptionsUseCaseType)),
    __metadata("design:paramtypes", [Object])
], ShareViewModel);
export { ShareViewModel };
